import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AccountService } from '../../../services/account.service';
import { ProfileService } from '../../../services/profile.service';
import { MDBSpinningPreloader } from 'ng-uikit-pro-standard';
import { Data, NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterOutlet } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import dayjs from 'dayjs';
import { filter, map } from 'rxjs/operators';
import { simpleFadeAnimation } from '../../route-animations';
import { ManifestService } from '../../../services/manifest.service';
import { CurrentDataService } from '../../../services/current-data-service';
import { CookieRunService } from '../../../services/cookie-run.service';

@Component({
  selector: 'jhi-main-with-theme',
  templateUrl: './main-with-theme.component.html',
  styleUrls: ['./main-with-theme.component.scss'],
  animations: [simpleFadeAnimation],
})
export class MainWithThemeComponent implements OnInit, OnDestroy, AfterViewInit {
  subscription?: Subscription;
  authSubscription?: Subscription;
  inProduction = false;
  swaggerEnabled = false;
  theme!: string;

  private cookiesPolicyLink = '';

  constructor(
    public accountService: AccountService,
    protected profileService: ProfileService,
    private mdbSpinningPreloader: MDBSpinningPreloader,
    private router: Router,
    private ngxSpinnerService: NgxSpinnerService,
    private currentDataService: CurrentDataService,
    private cookieRunService: CookieRunService
  ) {
    // nécessaire pour setter moment avec le local fr
    dayjs.locale('fr');
    this.currentDataService.getCurrentTheme().subscribe(() => {
      // TODO récupérer le bon theme
      const theme = 'wepal';
      this.theme = theme;
      document.body.classList.add(theme + '-skin');
    });

    this.currentDataService.getCurrentTransporter().subscribe(transporter => {
      ManifestService.createTransporterManifest(transporter!);
    });
  }

  public ngOnInit(): void {
    this.mdbSpinningPreloader.stop();
    this.cookiesPolicyLink = new URL(window.location.href).origin + '/cookies';

    this.profileService.getProfileInfo().subscribe(profileInfo => {
      if (profileInfo) {
        if (profileInfo.inProduction) {
          this.inProduction = profileInfo.inProduction;
        }
        if (profileInfo.openAPIEnabled) {
          this.swaggerEnabled = profileInfo.openAPIEnabled;
        }
      }
    });

    this.router.events
      .pipe(
        filter(e => e instanceof NavigationStart || e instanceof NavigationEnd || e instanceof NavigationCancel || e instanceof NavigationError),
        map(e => e instanceof NavigationStart)
      )
      // true or false
      .subscribe((isLoading: boolean) => {
        if (isLoading) {
          this.ngxSpinnerService.show();
        } else {
          this.ngxSpinnerService.hide();
        }
      });
  }

  ngAfterViewInit(): void {
    if (window.location.href !== this.cookiesPolicyLink) {
      this.cookieRunService.run(this.cookiesPolicyLink);
    }
  }

  public prepareRoute(outlet: RouterOutlet): Data {
    return outlet?.activatedRouteData;
  }

  public ngOnDestroy(): void {
    if (this.authSubscription) {
      this.authSubscription.unsubscribe();
    }
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  public isAuthenticated(): boolean {
    return this.accountService.isAuthenticated();
  }

  public isHomePage(): boolean {
    // Si homepage alors url = / sinon l'url est complété
    return this.router.url === '/';
  }
}
